<script>
    import i18n from "./i18n.js";
    import { MyAnalytics } from "./lib/firebase/firebase";
    import {Router} from "@sveltech/routify";
    import {routes} from "@sveltech/routify/tmp/routes";
    import {setContext} from "svelte";

    setContext('MyAnalytics', MyAnalytics);

    window.document.body.classList.add(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'bootstrap-dark' : 'bootstrap');
</script>

<svelte:head>
    <link rel="stylesheet" href="/vendor/bootstrap/bootstrap.min.css">
    <link rel="stylesheet" href="/vendor/bootstrap/bootstrap-dark.min.css" media="(prefers-color-scheme: dark)">
</svelte:head>

<Router {routes}/>